import { Link } from "react-router-dom";
import { Wordmark } from "@/components/common/Wordmark";
import { Ridgeline } from "@/components/common/Ridgeline";
import { Reveal } from "@/components/common/Reveal";
import { useAudienceMode } from "@/hooks/useAudienceMode";

const LIVE_COL = {
  title: "Live",
  links: [
    { label: "Browse rentals", to: "/rentals" },
    { label: "Residences", to: "/residences" },
    { label: "Neighbourhoods", to: "/neighbourhoods" },
    { label: "Book a showing", to: "/contact" },
  ],
};
const OWN_COL = {
  title: "Own",
  links: [
    { label: "For owners", to: "/owners" },
    { label: "Free rent analysis", to: "/owners#analysis" },
    { label: "How we manage", to: "/owners" },
  ],
};
const ROAM_COL = {
  title: "ROAM",
  links: [
    { label: "About", to: "/about" },
    { label: "Neighbourhood guides", to: "/neighbourhoods" },
    { label: "Contact", to: "/contact" },
  ],
};

export const Footer = () => {
  // Renter-facing pages lead with "Live"; owner-facing pages lead with "Own".
  const audience = useAudienceMode();
  const COLUMNS =
    audience === "renter"
      ? [LIVE_COL, OWN_COL, ROAM_COL]
      : [OWN_COL, LIVE_COL, ROAM_COL];
  return (
    <footer
      className="grain relative overflow-hidden"
      style={{ backgroundColor: "#14231B", color: "#EDE9E0" }}
      data-nav-theme="dark"
      data-testid="footer"
    >
      <div className="relative z-10 mx-auto max-w-[1440px] px-6 pt-24 pb-10 md:px-10">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
          <div className="md:col-span-6">
            <Reveal>
              <span
                className="font-expanded font-extrabold block"
                style={{
                  color: "#EDE9E0",
                  letterSpacing: "0.14em",
                  fontSize: "clamp(56px, 12vw, 150px)",
                  lineHeight: 0.9,
                }}
              >
                RO<span style={{ color: "#C89A4E" }}>A</span>M
              </span>
              <p
                className="font-display mt-4 italic"
                style={{ color: "#AEC4C7", fontSize: "clamp(24px,3vw,34px)" }}
              >
                Go far. Come home.
              </p>
            </Reveal>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-6">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <p className="eyebrow mb-5" style={{ color: "#C89A4E" }}>
                  {col.title}
                </p>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-[15px] transition-colors duration-300 hover:text-larch-bright"
                        style={{ color: "rgba(237,233,224,0.78)" }}
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-4 border-t pt-8 md:flex-row md:items-center md:justify-between"
          style={{ borderColor: "rgba(200,154,78,0.2)" }}>
          <p className="label-caps text-[11px]" style={{ color: "rgba(174,196,199,0.85)" }}>
            Calgary, Alberta · Treaty 7 territory
          </p>
          <p className="text-[13px]" style={{ color: "rgba(237,233,224,0.5)" }}>
            © {new Date().getFullYear()} ROAM Living — a boutique rental company.
          </p>
        </div>

        <p className="mt-10 text-[13px] italic" style={{ color: "rgba(174,196,199,0.7)" }}>
          You've roamed all the way down. Respect.
        </p>
      </div>

      <div className="relative z-0 w-full opacity-80" aria-hidden="true">
        <Ridgeline stroke="#C89A4E" variant="b" height={140} />
      </div>
    </footer>
  );
};

export default Footer;
